var _rect, _g, _defs, _path, _path2, _g2, _path3, _g3, _g4, _g5, _g6, _g7, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-0dd9719b": "",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "84 90 70 70",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-v-0dd9719b": "",
    fill: "#1582c7",
    className: "icon-text-wrapper icon-svg-group iconsvg",
    transform: "translate(87.19499969482422,92.39199829101562)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1582c7",
    className: "iconsvg-imagesvg icon_container",
    transform: "translate(0,2.608001708984375)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#1582c7",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    className: "image-svg-svg bn",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "hollow-target": ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      overflow: "visible"
    },
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    filtersec: "colorsf4568306569",
    filter: "url(#PeT5Do9njstnLQe68QztT)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1, 1) skewX(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0C50.45 0 65 14.55 65 32.5V65H32.5C14.55 65 0 50.45 0 32.5S14.55 0 32.5 0zm.488 3.004L32.5 3C16.208 3 3 16.208 3 32.5c0 16.13 12.945 29.236 29.012 29.496L32.5 62H62V32.5C62 16.532 49.313 3.527 33.469 3.016l-.481-.012z",
    fill: "#000",
    fillRule: "nonzero",
    strokeWidth: 2.9,
    strokeLinejoin: "round",
    stroke: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "PeT5Do9njstnLQe68QztT"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.08203125  0 0 0 0 0.5078125  0 0 0 0 0.77734375  0 0 0 1 0"
  })))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#colors7864875972)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 9.399999999999999,
    y: 9.399999999999999,
    viewBox: "5.813999652862549 11.225001335144043 89.07999420166016 77.55000305175781",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    width: 41.2,
    height: 41.2,
    className: "image-svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.444,64.885h-2.61c-3.31,0-6.02-2.71-6.02-6.02v-11.59c0-3.31,2.71-6.03,6.02-6.03h1.69c-0.94,3.31-1.44,6.81-1.44,10.42  C12.084,56.315,12.914,60.765,14.444,64.885z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.894,47.275v11.59c0,3.31-2.71,6.02-6.02,6.02h-2.98c1.53-4.12,2.36-8.57,2.36-13.22c0-3.61-0.5-7.11-1.44-10.42h2.06  C92.184,41.245,94.894,43.965,94.894,47.275z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.164,14.555c-20.49,0-37.1,16.61-37.1,37.11c0,20.49,16.61,37.11,37.1,37.11c20.5,0,37.11-16.62,37.11-37.11   C87.274,31.165,70.664,14.555,50.164,14.555z M50.164,79.805c-15.54,0-28.14-12.6-28.14-28.14s12.6-28.15,28.14-28.15   c15.55,0,28.15,12.61,28.15,28.15S65.714,79.805,50.164,79.805z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.334,15.515c0,1.9-1.23,3.51-2.93,4.08v1.52c-0.94,0.7-1.85,1.45-2.73,2.24v-3.76c-1.71-0.57-2.93-2.18-2.93-4.08  c0-2.37,1.92-4.29,4.3-4.29C28.414,11.225,30.334,13.145,30.334,15.515z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.327,63.379H44.011c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h12.316c0.276,0,0.5,0.224,0.5,0.5   S56.604,63.379,56.327,63.379z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.553,50.778c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l4.948-4.948   c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-4.948,4.948C59.064,50.681,58.809,50.778,58.553,50.778z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.501,50.778c-0.256,0-0.512-0.098-0.707-0.293l-4.948-4.948c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0   l4.948,4.948c0.391,0.391,0.391,1.023,0,1.414C64.013,50.681,63.757,50.778,63.501,50.778z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.506,50.778c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l4.948-4.948   c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-4.948,4.948C36.018,50.681,35.762,50.778,35.506,50.778z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.454,50.778c-0.256,0-0.512-0.098-0.707-0.293l-4.948-4.948c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0   l4.948,4.948c0.391,0.391,0.391,1.023,0,1.414C40.966,50.681,40.71,50.778,40.454,50.778z"
  }))))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "colors7864875972"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.19921875  0 0 0 0 0.19921875  0 0 0 0 0.19921875  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsf4568306569"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsb6425920841"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })))))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotImage);
export default __webpack_public_path__ + "static/media/bot-image.ae7f070805ef1d054b1a302f96d51a8c.svg";
export { ForwardRef as ReactComponent };